export const DialogType = {
    INVITEUSER: "inviteUser"
}